import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { NQError, WarningDE } from '@visonum/network-quality-sdk';
import { AssertionError } from 'assert';
import { AppThunk } from '../../store';
import { logger } from '../../helper/logger';
import { sentryReportWarning } from '../sentryReports/sentryCaptureError';

export interface ErrorState {
  lastError: NQError | null
}

const initialState: ErrorState = {
  lastError: null
}

export const reportWarning = (warning: WarningDE): AppThunk => (dispatch, getState) => {
  logger.warn(warning.message, { url: warning.url });
  sentryReportWarning(warning);
}

export const errorSlice = createSlice({
  name: 'error',
  initialState,
  reducers: {
    reportNQError: (state, action: PayloadAction<NQError>) => {
      state.lastError = action.payload
    },
    resetError: (state) => {
      state.lastError = null
    }
  }
});

export const { reportNQError, resetError } = errorSlice.actions;

export class AppAssertionError extends AssertionError {
  constructor(options?: {
    /** If provided, the error message is set to this value. */
    message?: string | undefined;
    /** The `actual` property on the error instance. */
    actual?: any;
    /** The `expected` property on the error instance. */
    expected?: any;
    /** The `operator` property on the error instance. */
    operator?: string | undefined;
    /** If provided, the generated stack trace omits frames before this function. */
    // tslint:disable-next-line:ban-types
    stackStartFn?: Function | undefined;
  }) {
    super(options)
  }
}

export default errorSlice.reducer;